import React from "react";
import Paper from '@mui/material/Paper';
import Grow from '@mui/material/Grow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function TitleGrows({ txtTitle }) {

    return (
        <>
            <Grow
                in={true}
                style={{ transformOrigin: '0 0 0' }}
                timeout= {500}
            >
                <Paper elevation={1} sx={{ width: "fit-content", marginBottom: "10px" }}>
                    <FontAwesomeIcon icon={['fas', 'chevron-right']} size={'1x'} color={'#198754'}
                        style={{ marginLeft: "10px" }} />
                    <span className="p-2 fs-5 fw-bold" style={{ color: "grey" }}>
                        {txtTitle.toString().toUpperCase()}
                    </span>
                </Paper>
            </Grow>
        </>
    )
}
